import React from 'react';
import Grid from '@material-ui/core/Grid';

const MiddleLayer = ({ children, size }) => {
  return (
    <Grid
      style={size ? { size: `${size.toString()}vh` } : { height: '43vh' }}
      xs={12}
      item
      container
    >
      {children}
    </Grid>
  );
};

export default MiddleLayer;
